import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography,
  IconButton,
  Tooltip,
  InputAdornment
} from '@mui/material';
import {
  Share as ShareIcon,
  Visibility as ViewIcon,
  ContentCopy as ContentCopyIcon
} from '@mui/icons-material';
import { message } from 'antd';

/**
 * Public paylaşım dialog bileşeni
 */
const ShareDialog = ({ 
  open, 
  onClose, 
  selectedForm 
}) => {
  const handleCopyLink = () => {
    if (selectedForm?.publicUrl) {
      navigator.clipboard.writeText(selectedForm.publicUrl);
      message.success('Link panoya kopyalandı!');
    }
  };

  const handlePreview = () => {
    if (selectedForm?.publicUrl) {
      window.open(selectedForm.publicUrl, '_blank');
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        <Box display="flex" alignItems="center">
          <ShareIcon sx={{ mr: 1 }} />
          Public {selectedForm?.viewType === 'spreadsheet' ? 'Tablo' : 'Form'} Paylaşımı
        </Box>
      </DialogTitle>
      
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Typography variant="h6" gutterBottom>
            {selectedForm?.title}
          </Typography>
        </Box>
        
        <TextField
          label="Public Paylaşım Linki"
          value={selectedForm?.publicUrl || ''}
          fullWidth
          variant="outlined"
          InputProps={{
            readOnly: true,
            endAdornment: (
              <InputAdornment position="end">
                <Tooltip title="Linki Kopyala">
                  <IconButton
                    onClick={handleCopyLink}
                    edge="end"
                  >
                    <ContentCopyIcon />
                  </IconButton>
                </Tooltip>
              </InputAdornment>
            )
          }}
          sx={{ mb: 2 }}
        />
        
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            variant="contained"
            startIcon={<ViewIcon />}
            onClick={handlePreview}
            fullWidth
          >
            Önizleme
          </Button>
          <Button
            variant="outlined"
            startIcon={<ContentCopyIcon />}
            onClick={handleCopyLink}
            fullWidth
          >
            Linki Kopyala
          </Button>
        </Box>
      </DialogContent>
      
      <DialogActions>
        <Button onClick={onClose}>
          Kapat
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShareDialog;
